import React, { useEffect, useState } from "react";
import { FiSearch, FiFilter } from "react-icons/fi";

export default function HeaderFilter({
  getUserList,
  selectedTime,
  setSelectedTime,
  hasFilter = true,
}) {
  const [timeoutId, setTimeoutId] = useState(null);

  const handleSearch = (e) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(() => {
        const searchQuery = e.target.value;
        getUserList(1, searchQuery.trim()); // Fetch channels with the search query
      }, 200)
    );
  };
  return (
    <div className="mt-4 flex justify-between items-center gap-4 p-4 bg-white rounded-xl rounded-b-none">
      {/* Search Input with Icon */}
      <div className="flex items-center gap-2">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2  transform -translate-y-1/4 text-[#000]" />
          <input
            onChange={handleSearch}
            type="text"
            placeholder="Search..."
            className="pl-10 pr-4 py-2 w-96 border text-sm border-[#EBEBEB] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Filter Icon */}
        {/* <button className="p-2 rounded-md border hover:bg-gray-100">
          <FiFilter className="text-lg" />
        </button> */}
      </div>
      {/* Sort Label and Select */}
      {hasFilter && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-black">Filter by</span>
          <select
            onChange={(ev) => setSelectedTime(ev.target.value)}
            className="py-2 text-sm px-3 border pr-5 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" selected={selectedTime == ""}>
              No Filter
            </option>
            <option value="TODAY" selected={selectedTime == "TODAY"}>
              Today
            </option>
            <option value="THIS_WEEK" selected={selectedTime == "THIS_WEEK"}>
              This Week
            </option>
            <option value="THIS_MONTH" selected={selectedTime == "THIS_MONTH"}>
              This Month
            </option>
          </select>
        </div>
      )}
    </div>
  );
}
